import { RouteRecordRaw } from "vue-router"
import PageCompany from "./pages/PageCompany.vue"
import PageCompanySources from "./pages/PageCompanySources.vue"
import { useAuthStore } from "@core/stores/auth.store"
import {
    redirectionVersSources,
    ROUTE_SOURCES_FACTUREES,
} from "./components/company/billing/billingSourceCriteres"

/**
 * Accès à l'espace entreprise : client Homeys ou UC2 Pro. Au rechargement,
 * les données user (companyId, subscription) peuvent ne pas être encore
 * chargées ; s'assurer de les avoir avant de vérifier les droits.
 */
async function accesEspaceEntreprise(): Promise<boolean> {
    const authStore = useAuthStore()
    if (authStore.isLogged && !authStore.userId) {
        await authStore.fetchUser()
    }
    return Boolean(authStore.isClientHomeys || authStore.isUc2Pro)
}

// ====================================
// Module Company Space - Routes
// ====================================
export const routes = [
    {
        path: "/user/entreprise",
        name: "PageCompany",
        component: PageCompany,
        meta: {
            requiresAuth: true,
            layout: "header-sidebar",
            sidebar: "user",
        },
        beforeEnter: async (to, _from, next) => {
            if (!(await accesEspaceEntreprise())) {
                next({ name: "PageUserSettings" })
                return
            }
            // Lien des courriels d'alerte de plafond
            // (`/user/entreprise?si_supprimee=libere#subscriptions`) : la liste
            // filtrée est désormais une page (demande du 16/10)
            const sources = redirectionVersSources(to.query)
            if (sources) {
                next(sources)
                return
            }
            next()
        },
    },
    {
        path: "/user/entreprise/sources",
        name: ROUTE_SOURCES_FACTUREES,
        component: PageCompanySources,
        meta: {
            requiresAuth: true,
            layout: "header-sidebar",
            sidebar: "user",
        },
        beforeEnter: async (_to, _from, next) => {
            if (!(await accesEspaceEntreprise())) {
                next({ name: "PageUserSettings" })
                return
            }
            // la liste des sources est réservée aux administrateurs de
            // l'entreprise, comme le décompte de la carte ; sans la query
            // (sinon la page Entreprise renverrait ici)
            if (!useAuthStore().isCompanyAdmin) {
                next({ name: "PageCompany" })
                return
            }
            next()
        },
    },
] as RouteRecordRaw[]
